module.exports = __webpack_public_path__ + "media/wyposazenie/kolor@3x-84edbb2b.svg";